import React from "react";
import { Link, useNavigate } from "react-router-dom";

function Terms() {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-b from-[#000000] to-[#1a1a1a] min-h-screen">
      <head>
        <link rel="icon" href="/img/logo_trans.png" />
        <title>Emotionly - Terms & Conditions</title>
        <meta
          name="description"
          content="Discover a new way to connect and improve your emotional well-being with our innovative app. Emotionly is a personal emotional tracker that helps you gain insight into your feelings, patterns, and triggers. With daily tracking and analysis, you can develop self-awareness, enhance your emotional intelligence, and manage your mental health effectively. Our app is perfect for anyone looking to build deeper connections based on emotional compatibility, track their moods and emotions, and enhance their overall well-being. Download Emotionly today and start exploring the power of emotional tracking for a happier, healthier you!"
        />
        <meta
          property="og:title"
          content="Emotionly - Connect through Emotions"
        />
        <meta
          property="og:description"
          content="Discover a new way to connect and improve your emotional well-being with our innovative app. Emotionly is a personal emotional tracker that helps you gain insight into your feelings, patterns, and triggers. With daily tracking and analysis, you can develop self-awareness, enhance your emotional intelligence, and manage your mental health effectively. Our app is perfect for anyone looking to build deeper connections based on emotional compatibility, track their moods and emotions, and enhance their overall well-being. Download Emotionly today and start exploring the power of emotional tracking for a happier, healthier you!"
        />
        <meta property="og:url" content="https://emotionly.app/" />
        <meta property="og:type" content="website" />
      </head>
      <main className="flex min-h-screen min-w-full flex-col items-center justify-between p-4">
        <div className="z-10 w-full items-center justify-between font-mono text-sm lg:flex">
          <div className="relative py-3 w-full sm:mx-auto">
            <div
              className="px-2 sm:px-10 py-4 w-full min-h-[94vh] flex flex-col bg-white shadow-2xl rounded-3xl bg-clip-padding bg-opacity-10 border border-gray-100"
              style={{ backdropFilter: "blur(60px)" }}
            >
              <Link to={"/"}>
                <img
                  className="  "
                  src="/img/logo_trans.png"
                  alt="Picture of the author"
                  width={60}
                  height={60}
                />
              </Link>
              <h1 className="text-white text-center mt-3 sm:mt-1 font-roboto font-bold text-2xl sm:text-3xl ">
                Terms & Conditions
              </h1>

              <div className="mt-3 px-3 sm:px-10 text-white font-roboto mb-5 page-content">
                <p>
                  These Terms and Conditions are a legal and binding Agreement
                  between You (“the User”) and Emotionly (hereinafter referred
                  to as <strong>"Emotionly"</strong>). Terms and Conditions
                  state the grounds on which the User can use and/ or register
                  with this <a href="https://emotionly.app">Emotionly.app</a> (
                  <strong>
                    “App”/ “Website”/ “Us”/ “We”/ “Our”/ Emotionly)
                  </strong>
                  . Terms and Conditions are updated from time to time at Our
                  sole discretion and the most updated version is available on
                  the Site at all times along with the date of last revision.
                  Continued use by the User of the Site after any revision
                  indicates the User’s acceptance of the updated/ revised Terms
                  and Conditions.
                </p>
                <p>
                  BY USING OUR APP, YOU ARE ACCEPTING THE PRACTICES DESCRIBED IN
                  THESE TERMS OF SERVICE. IF YOU DO NOT AGREE TO THESE TERMS OF
                  SERVICE, PLEASE DO NOT USE THE APP AND EXIT IMMEDIATELY. WE
                  RESERVE THE RIGHT TO MODIFY OR AMEND THESE TERMS OF SERVICE
                  FROM TIME TO TIME WITHOUT NOTICE. YOUR CONTINUED USE OF OUR
                  APP FOLLOWING THE POSTING OF CHANGES TO THESE TERMS WILL MEAN
                  YOU ACCEPT THOSE CHANGES. UNLESS WE PROVIDE YOU WITH SPECIFIC
                  NOTICE, NO CHANGES TO OUR TERMS OF USE WILL APPLY
                  RETROACTIVELY.{" "}
                </p>

                <br />

                <ol start={"1"}>
                  <li className=" font-semibold ">1. Eligibility</li>

                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <u> Minimum Age :</u> User of the Site must be at least 18
                      years old to use or to register on the App for the
                      Services. By using the Services on the Site, the User
                      represents and warrants that he/ she is a minimum 18 years
                      old. It is possible that certain Services may have other
                      age requirements and such other age requirements are
                      stated at the relevant places.{" "}
                    </li>
                    <li className="py-1">
                      <u>Criminal History.</u> By requesting to use, registering
                      to use, and/or using the Service, the User represents and
                      warrants that the User has never been convicted under any
                      law governing us or the User. Emotionly reserves the right
                      to conduct a criminal background check, at any time and
                      using available public records, to confirm possibility of
                      misrepresentation. By agreeing to these Terms and
                      Conditions, the User consents to and authorises such
                      check.{" "}
                    </li>
                    <li className="py-1">
                      <u>Verification.</u> By agreeing to the Terms and
                      Conditions, User hereby authorises Emotionly (and its
                      third party authentication agency) to conduct verification
                      checks on the User/ You.
                      <p>
                        User agrees and understands that Emotionly or its third
                        party expert service provider and their associates are
                        not the author or creator of the information coming
                        forth in the Verification Checks. Under this premise and
                        limitations, Emotionly or its third party expert service
                        provider or their associates do not warrant accuracy,
                        validity or completeness of the content of the
                        Verification checks. Emotionly, expressly disclaims that
                        the Verification checks will meet the User’s aspirations
                        or expectations and shall be performed in an
                        uninterrupted manner. Verification check verifies the
                        existence of the facts and information provided by the
                        User, it does not verify the authenticity of the facts
                        itself.
                      </p>
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">
                    2. Use of App & Services
                  </li>

                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <u>Personal Use : </u> Once an account is created with on
                      Emotionly, it is for the User’s personal use only. The
                      User may not authorize others to use the account. The
                      account with the Site is non assignable and
                      non-transferable to any third party whether a person or an
                      entity. The User acknowledges and confirms that Emotionly
                      is not responsible for third party access to the User’s
                      account that results from theft, hacking or
                      misappropriation of user names and passwords.{" "}
                    </li>
                    <li className="py-1">
                      <u>Geographical : </u> The User agrees to at all times use
                      the Services &nbsp;in a manner consistent with this Terms
                      and Conditions and any and all applicable local, state,
                      national and international laws and regulations,
                      including, but not limited to, the one’s of the location
                      where the User is located or is a national of. By using
                      the Services, as a User You represent that you have not
                      been designated by any applicable law or regulation as a
                      person / entity to whom the provisions of the Services can
                      not be provided and who is prohibited from receiving the
                      Services. Registration for, and use of, the Services
                      become void if the same have been prohibited and the User
                      uses or registers with the App. You are responsible for
                      determining whether the user of the Services is legal in
                      your jurisdiction{" "}
                    </li>
                    <li className="py-1">
                      <u>Information Submitted : </u> The User is solely
                      responsible for, and assume all liability regarding, (i)
                      the information and content provided at the App for the
                      Service; (ii) the information and content the User posts,
                      transmits, publishes, shares or otherwise makes available
                      (hereinafter<strong>"Post"</strong>) to Emotionly for the
                      Services; (iii) User interactions with other Registered
                      Users through the Services; and (iv) the information
                      provided in the Personality Assessment. The app shares
                      User information with the specific User’s matches.{" "}
                    </li>
                    <li className="py-1">
                      <u>Risk Assumption and Precautions : </u> All risks when
                      using the Services and the app, including but not limited
                      to all of the risks associated with any online or offline
                      interactions with others, including meeting other people
                      having same emotions remain with the User. The User is
                      expected to use his / her best judgement in experiencing
                      any of the benefits/ requirements of the Services / App.
                      The User agrees to take all necessary precautions when
                      meeting individuals through the App and under the
                      Services. In addition, the User agrees and confirms to
                      review and follow the recommendations set forth in the App
                      as pointers to Safety and/ or mailed to User from time to
                      time. The User undertakes to adhere to the Safety pointers
                      and shall all times be responsible for all outcomes of
                      meeting/ sharing information and/ or being in a short or a
                      long term relationship through the Services/ App. It is
                      accepted and understood by the User that at all times the
                      User shall use his/ her judgement and discretion in
                      receiving the Services through the App.{" "}
                    </li>
                    <li className="py-1">
                      <u>No Guarantee : </u> Emotionly through the App and its
                      specific systems attempts to find people having same
                      emotions & thoughts on a best effort basis, however, every
                      User may not find ideal matches through the App.
                      Furthermore, Emotionly does not make any representations
                      or guarantees regarding the number or frequency of matches
                      through the App, or the ability, desire or criteria of
                      such proposed people to communicate with the User. The
                      User fully understands and accepts that Emotionly makes no
                      guarantees, either express or implied, direct or indirect,
                      regarding User’s ultimate compatibility with matches’/
                      individuals the User meets through the Service or as to
                      the conduct of such individuals.{" "}
                    </li>
                    <li className="py-1">
                      <u>Background and Verification Checks : </u> Emotionly
                      engages with third party experts for conducting basic
                      background verification checks and does not take any
                      guarantees for the same other than as offered,
                      represented, warranted and undertaken by such third party
                      experts providing these services to Emotionly. By
                      accepting the Terms and Conditions and having a Registered
                      Account with the App, the User has agreed to get the Self
                      Verification Process completed. User agrees and accepts
                      that if the User refuses/ fails to get the Verification
                      check completed then, Emotionly at its sole discretion,
                      without any recourse from the User, have the right to
                      terminate the Account. The set of Services offered at the
                      App are linked to completion of the Verification process
                      and the User may receive corresponding permits based on
                      the Verification.{" "}
                    </li>
                    <li className="py-1">
                      <u>
                        No Tolerance for Objectionable Content or Abusive Users.
                      </u>{" "}
                      Abuse, trolling, inappropriate &amp; objectionable content
                      such as (but not limited to) threats, nudity, obscenity
                      etc. are an immediate violation of the Terms of Use of
                      Emotionly. If any such violation is brought Our attention
                      via a “Report User” mechanism or other mechanism,
                      Emotionly will take strict and relevant action against
                      such violation.{" "}
                    </li>
                    <li className="py-1">
                      <u>Content Removal : </u> Emotionly reserves the right,
                      but has no obligation, to monitor the information or
                      material User submits to the App or the Journals / Posts
                      in the public areas of the Services or linked to other
                      public sites. Emotionly at all times reserves all rights
                      to remove any such information or material that in its
                      sole opinion violates, or may violate, any applicable law
                      or either the letter or spirit of this Terms and
                      Conditions or the integrity of any other User or upon the
                      request/ report of any third party. Emotionly reserves the
                      right to remove matches previously delivered to the User,
                      in its sole discretion, in order to maintain the quality
                      of experience and authenticity of the App, without any
                      recourse from the User.{" "}
                    </li>
                    <li className="py-1">
                      <u>Posting and Communication Restrictions.</u> The User
                      will not post on the Services, transmit to other users,
                      communicate any content (or links thereto), or otherwise
                      engage in any activity on the App, which:{" "}
                    </li>
                    <ul className="list-disc py-1 ml-10">
                      <li>
                        promotes any kind of discriminatory material, racism,
                        bigotry, hatred, or physical harm of any kind against
                        any group or individual;{" "}
                      </li>
                      <li>
                        is intended to or tends to harass, annoy, threaten or
                        intimidate any other users of the Site or Services;
                      </li>
                      <li>
                        is defamatory, inaccurate, abusive, obscene, profane,
                        offensive, sexually oriented, obscene or otherwise
                        objectionable;
                      </li>
                      <li>
                        contains others' copyrighted content (e.g., music,
                        movies, videos, photographs, images, software, etc.)
                        without prior approval of the owner;{" "}
                      </li>
                      <li>
                        contains video, audio photographs, or images of another
                        person without his or her permission (or in the case of
                        a minor, the minor's legal guardian);{" "}
                      </li>
                      <li>
                        promotes or enables illegal or unlawful activities, such
                        as instructions on how to make or buy illegal weapons or
                        drugs, violate someone's privacy, harm or harass another
                        person, obtain others' identity information, create or
                        disseminate computer viruses, or circumvent copy-protect
                        devices;{" "}
                      </li>
                      <li>
                        intended to defraud, swindle or deceive other users of
                        the Services;
                      </li>
                      <li>
                        contains viruses, time bombs, trojan horses, cancelbots,
                        worms or other harmful, or disruptive codes, components
                        or devices;
                      </li>
                      <li>
                        promotes or solicits involvement in or support of a
                        political platform, religion, cult, or sect;
                      </li>
                      <li>
                        disseminates another person's personal information
                        without his or her permission, or collects or solicits
                        another person's personal information for commercial or
                        unlawful purposes;{" "}
                      </li>
                      <li>
                        is off-topic, meaningless, or otherwise intended to
                        annoy or interfere with others' enjoyment of the Site;
                      </li>
                      <li>
                        impersonates, or otherwise misrepresents affiliation,
                        connection or association with, any person or entity;
                      </li>
                      <li>
                        solicits gambling or engages in any gambling or similar
                        activity;
                      </li>
                      <li>
                        uses anything or other automated technology to access
                        the Site or Services;
                      </li>
                      <li>
                        uses the Site or Services for chain letter, junk mail or
                        spam e-mails;
                      </li>
                      <li>
                        collects or solicits personal information about anyone
                        under 18 years of age; or
                      </li>
                      <li>
                        is in any way used for or in connection with spamming,
                        spimming, phishing, trolling, or similar activities.
                      </li>
                    </ul>
                    <li className="py-1">
                      <u>No False Information.</u> By registering with the App,
                      the User undertakes not to provide inaccurate, misleading
                      or false information to Emotionly or to any other user or
                      recommended/ suggested matches. If information provided to
                      Emotionly, or at the App or another user subsequently
                      becomes inaccurate, misleading or false, within the User’s
                      knowledge then the User will promptly notify the App of
                      such change or discontinue usage of the App/ Services if
                      User does not require the Services any longer.{" "}
                    </li>

                    <li className="py-1">
                      <u>No Advertising or Commercial Solicitation.</u> The User
                      undertakes not to advertise or solicit any user to buy or
                      sell any products or services through the App. User is
                      strictly prohibited against transmitting any chain
                      letters, junk or spam e-mail to other users. Further, no
                      User shall use any information obtained from the Services
                      in order to contact, advertise to, solicit, or sell to any
                      user without their prior explicit consent of Emotionly and
                      the other such User. It is clarified that any such use of
                      information shall be to the sole liability and
                      responsibility of the User engaging in such activity.
                      Breach by any of the Users of the terms of this subsection
                      and sending or posting unsolicited bulk email, "spam" or
                      other unsolicited communications of any kind through the
                      Services will cause substantial harm to Emotionly, and
                      that the amount of such harm would be extremely difficult
                      to ascertain. As a reasonable estimation of such harm, the
                      User shall be liable and agrees to pay Emotionly a minimum
                      of USD 10,000.00 for each such unsolicited communication.{" "}
                    </li>

                    <li className="py-1">
                      <u>Single Bona Fide Profile.</u> As a Registered User of
                      the Service, the User is expected to create only one bona
                      fide profile. In addition, it is stressed that the use of
                      the Service must be for journaling and finding people
                      having same emotions & thoughts in order to maintain the
                      integrity of the Services being offered through the App
                      (for example, User is discouraged from becoming a User for
                      casual relationships, solely to compile a report of
                      compatible singles in User’s area, or to write a school
                      research paper or create a databse for other similar sites
                      or creating and collating database for any such purpose).
                      From time to time, Emotionly creates test profiles in
                      order to monitor the operation of the Services and also
                      offers a feature to refer profiles/ prospective Users. The
                      Users, at their will, can accept these offers and refer
                      profiles to Emotionly. All references on the App, made by
                      a User shall be of his/ her free will and wish.{" "}
                    </li>

                    <li className="py-1">
                      <u>Selection of Profiles.</u> Emotionly may offer
                      promotions from time to time on the App and in the context
                      of the Services. Please note for any promotions on the
                      App, the User shall be under no obligation to accept the
                      same. The User acknowledges and accepts that the decision
                      to whether or not to accept the promotion offered or meet
                      or to proceed with meeting or engaging in any relationship
                      with any suggested/ recommended matches will be the sole
                      discretion of the User in question, Emotionly shall not be
                      liable or responsible for any outcome whatsoever of such
                      suggestions/ recommendations of matches or offering the
                      promotions on the App. It is clarified that all
                      suggestions/ recommendations are made in good faith and
                      with intentions of well being whether or not to explore
                      those suggestions/ recommendations are solely and totally
                      in the judgement and assessment of the User. User is
                      encouraged to review Our Safety pointers while proceeding
                      with any match in a more committed manner.{" "}
                    </li>

                    <li className="py-1">
                      <u>No Harassment of Emotionly Employees or Agents.</u> The
                      User is prohibited from harassing, annoying, intimidating
                      or threatening any Emotionly employees or agents engaged
                      in providing any portion of the Services. If any User
                      breaches this provision of these Terms and Conditions,
                      then Emotionly may take any legal action it deems
                      appropriate against such User without prejudice to
                      Emotionly’s any other rights in law or tort.{" "}
                    </li>

                    <li className="py-1">
                      <u>Social Media.</u> The App may provide User the option
                      to connect your account to any account on some social
                      networking sites (such as via Facebook, twitter etc.) for
                      the purpose of logging in, uploading information or
                      enabling certain features on the Service. Please note,
                      Emotionly owes no responsibility for privacy practices of
                      such websites which are not owned, controlled or managed
                      by Emotionly. If in following such links User may be asked
                      to share any information governed under these provisions
                      with the third party websites and thus the User shall be
                      solely responsible for sharing and handling, storing,
                      possessing and use of that information with such third
                      party websites. Usually, third party websites are governed
                      by their own Privacy guidelines and the User is encouraged
                      to review these carefully to understand the handling of
                      information at third party sites. The User is aware and
                      confirms that in such a scenario User will be governed and
                      bound by the policies of the third party website and
                      Emotionly will not be liable in any manner for any misuse,
                      thereunder. Each social network allows User to set privacy
                      controls around on their system, and Emotionly's
                      collection of information will always follow such controls
                      and permissions. This feature is subject to continuous
                      change and improvement by Emotionly and each social
                      networking site involved, and therefore the available
                      features and shared information are subject to change
                      without notice or consent of the User. All information
                      shared on the App by the User is used in compliance with
                      the Privacy Policy on the App. We recommend User reads the
                      Privacy Policy on the App, carefully.{" "}
                    </li>

                    <li className="py-1">
                      <u>Third Party recommendations</u>. Users registered/
                      registering on the App from third party corporate
                      recommendations will have to follow all procedures and
                      requirements specified on the App including the
                      Verification Process and shall be governed by these Terms
                      and Conditions and the Privacy Policy and are expected to
                      consider Our Safety Guidelines provided on the App. There
                      is no preferred User status for any User on the App. All
                      third party corporations recommending the Site among their
                      work force do so as per their company policies and do not
                      incur any liability from doing so or their referred User
                      receiving the Services on their account.{" "}
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">
                    3. Apple Related Disclaimer
                  </li>
                  <span className="c2" data-v-6df567d8="">
                    The following additional terms apply with respect to your
                    use of the App downloaded from the Apple App Store.
                  </span>

                  <ul className="gap-2 py-1 ">
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <u className="c8 c5" data-v-6df567d8="">
                        Acknowledgement
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : Organization and you acknowledge that these Terms of
                        Service constitutes the agreement between Emotionly and
                        you only, and not with Apple, and Organization, not
                        Apple, is solely responsible for any App and the content
                        thereof. To the extent these Terms of Service provide
                        for usage rules for any App that are less restrictive
                        than the Usage Rules set forth for the App in, or
                        otherwise is in conflict with, the Apple App Store Terms
                        of Service, the more restrictive or conflicting Apple
                        App Store term applies.
                      </span>
                    </li>
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <u className="c8 c5" data-v-6df567d8="">
                        Scope of License
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : The license granted to you for each App is limited to
                        a non-transferable license to use the App on an iOS
                        Product that you own or control and as permitted by the
                        Usage Rules set forth in the Apple App Store Terms of
                        Service.
                      </span>
                    </li>
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <u className="c5 c8" data-v-6df567d8="">
                        Maintenance and Support
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : Organization is solely responsible for providing any
                        maintenance and support services with respect to each
                        App, as specified in this Visitor Agreement (if any), or
                        as required under applicable law. Organization and you
                        acknowledge that Apple has no obligation whatsoever to
                        furnish any maintenance and support services with
                        respect to any App.
                      </span>
                    </li>
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <u className="c8 c5" data-v-6df567d8="">
                        Warranty
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : Organization is solely responsible for any product
                        warranties, whether express or implied by law, to the
                        extent not effectively disclaimed. In the event of any
                        failure of any App to conform to any applicable
                        warranty, you may notify Apple, and Apple will refund
                        the purchase price for the App to you; and to the
                        maximum extent permitted by applicable law, Apple will
                        have no other warranty obligation whatsoever with
                        respect to such App, and any other claims, losses,
                        liabilities, damages, costs or expenses attributable to
                        any failure to conform to any warranty will be
                        Organization’s sole responsibility.
                      </span>
                    </li>
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <u className="c8 c5" data-v-6df567d8="">
                        Product Claims
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : Organization and you acknowledge that Organization,
                        not Apple, is responsible for addressing any claims of
                        you or any third party relating to any App or your
                        possession and/or use of any App, including, but not
                        limited to: (i) product liability claims; (ii) any claim
                        that any App fails to conform to any applicable legal or
                        regulatory requirement; and (iii) claims arising under
                        consumer protection or similar legislation. This
                        provision does not limit Organization’s liability to you
                        beyond what is permitted by applicable law.
                      </span>
                    </li>
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <u className="c8 c5" data-v-6df567d8="">
                        Intellectual Property Rights
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : Organization and you acknowledge that, in the event of
                        any third party claim that any App or your possession
                        and use of any App infringes that third party’s
                        intellectual property rights, Organization, not Apple,
                        will be solely responsible for the investigation,
                        defense, settlement and discharge of any such
                        intellectual property infringement claim.
                      </span>
                    </li>
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <span className="c8 c5" data-v-6df567d8="">
                        Legal Compliance
                      </span>
                      <span className="c2" data-v-6df567d8="">
                        : You represent and warrant that (i) you are not located
                        in a country that is subject to a U.S. Government
                        embargo, or that has been designated by the U.S.
                        Government as a “terrorist supporting” country; and (ii)
                        you are not listed on any U.S. Government list of
                        prohibited or restricted parties.
                      </span>
                    </li>
                    <li className="c19 py-1 c1 li-bullet-0" data-v-6df567d8="">
                      <u className="c8 c5" data-v-6df567d8="">
                        Third Party Terms of Agreement
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : You must comply with any applicable third party terms
                        of agreement when using any App.
                      </span>
                    </li>
                    <li
                      className="c21  py-1 c1 c29 li-bullet-0"
                      data-v-6df567d8=""
                    >
                      <u className="c11 c8 c5" data-v-6df567d8="">
                        Third Party Beneficiary
                      </u>
                      <span className="c2" data-v-6df567d8="">
                        : Organization and you acknowledge and agree that Apple,
                        and Apple’s subsidiaries, are third party beneficiaries
                        of the agreement between Organization and you in this
                        Visitor Agreement, and that, upon your acceptance of
                        these Terms of Service, Apple will have the right (and
                        will be deemed to have accepted the right) to enforce
                        such agreement against you as a third party beneficiary
                        thereof.
                      </span>
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">4. Proprietary Rights</li>

                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <u>Ownership of Proprietary Information.</u> The User
                      confirms and agrees that Emotionly is the owner of highly
                      valuable proprietary information, including without
                      limitation, the patented compatibility emotions & thought
                      based matching, compatibility of user profiles, and other
                      information being shared on the App (collectively,{" "}
                      <strong>"Confidential Information"</strong>). Emotionly
                      owns and hereby retains all proprietary rights in the
                      Services / App, the information provided in the App,
                      including but not limited to, all Confidential
                      Information.{" "}
                    </li>
                    <li className="py-1">
                      <u>No Use of Confidential Information.</u> The User
                      undertakes to not post, copy, modify, transmit, disclose,
                      show in public, create any derivative works from,
                      distribute, make commercial use of, or reproduce in any
                      way any (i) Confidential Information or (ii) other
                      copyrighted or copyrightable material, trademarks, or
                      other proprietary information accessible via the App or
                      the information on the App without first obtaining the
                      prior written consent of Emotionly, who is the owner of
                      such proprietary rights.{" "}
                    </li>
                    <li className="py-1">
                      <u>Other Users' Information.</u> Other Registered Users
                      may post copyrighted information, which has copyright
                      protection whether or not it is identified as copyrighted.
                      The User undertakes not to copy, modify, publish,
                      transmit, distribute, perform, display, commercially use,
                      or sell any Confidential Information of Emotionly or any
                      information copyrighted or copyrightable or not of third
                      party proprietary information available via the Services
                      or the App.{" "}
                    </li>
                    <li className="py-1">
                      <u>License to Posted or Accessed Content.</u> By posting
                      information or content to any profile pages or public area
                      of the Services, or making it accessible to Emotionly by
                      linking the User account with the App to any social
                      network accounts (e.g. via Facebook, Instagram etc.), the
                      User grants unconditionally and in perpetuity, and
                      represents and warrants that the User has the right to
                      grant, to Emotionly and its users, an irrevocable,
                      perpetual, non-exclusive, fully-paid, worldwide license to
                      use, reproduce, publicly perform, publicly display and
                      distribute such information and content, and to prepare
                      derivative works of, or incorporate into other works, such
                      information and content, and to grant and authorize
                      sub-licenses of the foregoing. From time to time,
                      Emotionly may create, test or implement new features or
                      programs on the App in which the User may voluntarily
                      choose to participate or may be a part of a test group
                      with special access, in accordance with the additional
                      terms and conditions of such features or programs. By
                      participating in such features or programs, the User
                      grants and unconditional and perpetual right to Emotionly
                      and consents to terms and conditions (if any) of such
                      features or programs.{" "}
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">5. User Information</li>
                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <u>Privacy Statement.</u> For information about the
                      collection and possible use of information and material
                      provided by the User on the App please review the Privacy
                      Policy on the App.{" "}
                    </li>
                    <li className="py-1">
                      <u>No Contact Information.</u> User agrees that User will
                      not post any e-mail addresses, personal website address,
                      personal phone numbers on a third party website, or other
                      contact information in the "About Me" section of the App
                      or in any other communications the User may have with
                      other users. The User may, at his/ her discretion,
                      exchange such information after the User reaches
                      “anonymous messaging” phase with the appropriate people
                      based on their own consent.{" "}
                    </li>
                    <li className="py-1">
                      <u>Disclosure By Law.</u> The User is aware and agrees and
                      consents unconditionally to disclosures of information on
                      the App required to be made: i) under law by Emotionly;
                      ii) at the request of a third party under various consent
                      forms; iii) any investigative requirement, or if
                      Emotionly, in its sole discretion, believes that
                      disclosure is reasonable to (1) comply with the law,
                      requests or orders from law enforcement, or any legal
                      process (whether or not such disclosure is required by
                      applicable law); (2) protect or defend Emotionly's, or a
                      third party's, rights or property; or (3) protect
                      someone's health or safety, such as when harm or violence
                      against any person (including the user) is threatened; or
                      (4) in support of a fraud/ legal investigation/
                      verification checks.{" "}
                    </li>
                    <li className="py-1">
                      <u>Disclosure to Protect Abuse Victims.</u>{" "}
                      Notwithstanding any other provision of this Terms and
                      Conditions or the Privacy Policy, Emotionly reserves the
                      right, but has no obligation, to disclose any information
                      that the User submits on the App, if in its sole opinion,
                      Emotionly suspects or has reason to suspect, that the
                      information involves a party who may be the victim of
                      abuse in any form. Information may be disclosed to
                      authorities that Emotionly, in its sole discretion, deems
                      appropriate to handle such disclosure. Appropriate
                      authorities may include, without limitation, law
                      enforcement agencies, child protection agencies, or court
                      officials, expert professional investigative agencies. The
                      User understands the provisions of this subsection and
                      grants Emotionly unconditional, perpetual right and
                      permission to make such disclosure.{" "}
                    </li>
                    <li className="py-1">
                      <u>Use of Anonymous Information for Research.</u> By using
                      the Services, the User permits Emotionly to anonymously
                      use the information from the User and User experiences
                      through the Services to continue / contribute to
                      Emotionly's research into emotional connect and to improve
                      the experience and quality of the App. Such research is
                      conducted by psychologists and behaviour research
                      scientists on the panel of Emotionly, and may be published
                      in academic journals. However, all of User responses will
                      be anonymous, and nothing containing User’s personal
                      identifying information shall be published.{" "}
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">
                    6. Disclaimer of Warranty
                  </li>
                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <u>No Warranties.</u> THIS SECTION WILL APPLY TO THE
                      MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW. EMOTIONLY
                      PROVIDES THE SERVICES ON AN "AS IS" AND "AS AVAILABLE" AND
                      “BEST EFFORTS” BASIS AND GRANTS NO WARRANTIES OF ANY KIND,
                      WHETHER EXPRESS, IMPLIED, DIRECT, INDIRECT STATUTORY OR
                      OTHERWISE WITH RESPECT TO THE SERVICES OR THE RESULT OF
                      THE SERVICES OR THE APP (INCLUDING ALL INFORMATION
                      CONTAINED THEREIN), INCLUDING ANY IMPLIED WARRANTIES OF
                      CORRECTNESS, VALIDITY, ACCURACY APPRORPRIATENESS, FITNESS,
                      COMPATIBILITY FOR A PARTICULAR PURPOSE OR OUTCOME OR
                      NON-INFRINGEMENT. EMOTIONLY DOES NOT WARRANT THAT THE
                      &nbsp;USE OF THE SERVICES WILL BE SECURE, UNINTERRUPTED,
                      ALWAYS AVAILABLE, ERROR-FREE OR WILL MEET THE USER’S
                      REQUIREMENTS, OR THAT ANY DEFECTS IN THE SERVICES WILL BE
                      CORRECTED OR RESULT IN THE DESIRED RESULTS. NOR DOES IT
                      REPRESENT OR WARRANT THAT ANY PERSON IS OF THE HIGHEST
                      COMPATIBILITY. EMOTIONLY DISCLAIMS LIABILITY FOR, AND NO
                      WARRANTY IS MADE WITH RESPECT TO, THE CONNECTIVITY AND
                      AVAILABILITY OF THE SERVICES AT ALL TIMES AND THE RESULTS
                      OF THE USE OF THE SERVICES. EMOTIONLY DISCLAIMS LIABILITY
                      FOR THE OUTCOME OF THE VERIFICATION CHECKS FOR PARTICUALR
                      USER EXPECTATIONS OR ASPIRATIONS AND VERIFICATION OF FACTS
                      AND INFORMATION PROVIDED BY THE USER FOR SELF
                      VERIFICATION/ VERIFICATION CHECKS. ANY THIRD PARTY ENTITY
                      OR CORPORATE RECOMMENDING THESE SERVICES TO ANY USER WILL
                      NOT BE LIABLE FOR ANY SERVICES OR RESULTS THEREOF PROVIDED
                      TO THE USER. EMOTIONLY NOR ANY THIRD PARTY RECOMMENDING
                      ENTITY WARRANTS ANYTHING ABOUT THE USAGE, RESULTS,
                      OUTCOMES, PERFORMANCE OF THE SERVICES, EITHER DIRECTLY OR
                      INDIRECTLY AT ANY POINT IN TIME. ALL RISKS OF RECEIVING
                      THE SERVICES IS TO THE ACCOUNT OF THE USER WHO IS IN
                      COMPLETE AWARENESS AND WILLINGNESS WITHOUT ANY FORCE
                      SUSBSCRIBING TO THE SERVICES.{" "}
                    </li>
                    <li className="py-1">
                      <u>Third Party Content.</u> Opinions, advice, statements,
                      offers, or other information or content made available
                      through the Services, but not directly by Emotionly, are
                      those of their respective authors, and should not
                      necessarily be relied upon. Such authors are solely
                      responsible for such content. EMOTIONLY DOES NOT: (i)
                      GUARANTEE THE ACCURACY, COMPLETENESS OR USEFULNESS OF ANY
                      INFORMATION PROVIDED ON THE SERVICES, OR (ii) ADOPT,
                      ENDORSE OR ACCEPT RESPONSIBILITY FOR THE ACCURACY OR
                      RELIABILITY OF ANY OPINION, ADVICE, OR STATEMENT MADE BY
                      ANY PARTY OTHER THAN EMOTIONLY, OR (iii) THE BACKGROUND
                      VERIFICATION INFORMATION PROVIDED BY THE THIRD PARTY
                      EXPERT SERVICE PROVIDER AGENCY. UNDER NO CIRCUMSTANCES
                      WILL EMOTIONLY BE RESPONSIBLE FOR ANY LOSS OR DAMAGE
                      RESULTING FROM ANYONE'S RELIANCE ON INFORMATION OR OTHER
                      CONTENT POSTED ON THE SERVICES, OR TRANSMITTED TO OR BY
                      ANY USERS.{" "}
                    </li>
                    <li className="py-1">
                      <u>New Features.</u> From time to time, Emotionly may
                      offer new features or tools with which its users may
                      experiment on the Services. Such features or tools are
                      offered solely for experimental purposes and without any
                      warranty of any kind, and may be modified or discontinued
                      at Emotionly's sole discretion. The provisions of this
                      Disclaimer of Warranty section apply with full force to
                      such features or tools.{" "}
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">
                    7. Limitation of Liability
                  </li>
                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <u>Incidental Damages and Aggregate Liability.</u> TO THE
                      MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
                      WILL EMOTIONLY BE LIABLE FOR ANY INCIDENTAL, SPECIAL,
                      CONSEQUENTIAL OR INDIRECT DAMAGES ARISING OUT OF OR
                      RELATING TO THE USE OR INABILITY TO USE THE SERVICES,
                      RESULT OF USING THE SERVICES INCLUDING, WITHOUT
                      LIMITATION, DAMAGES FOR RECOMMENDATION OF THE APP, OUTCOME
                      OF VERIFICATION CHECKS, LOSS OR CORRUPTION OF DATA OR
                      PROGRAMS, SERVICE INTERRUPTIONS AND PROCUREMENT OF
                      SUBSTITUTE SERVICES, EVEN IF EMOTIONLY KNOWS OR HAS BEEN
                      ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TO THE MAXIMUM
                      EXTENT PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES
                      WILL EMOTIONLY BE LIABLE FOR ANY LIQUIDATED OR PUNITIVE
                      DAMAGES.{" "}
                    </li>
                    <li className="py-1">
                      <u>No Liability for Actions not by Emotionly</u> TO THE
                      MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
                      WILL EMOTIONLY BE LIABLE FOR ANY DAMAGES WHATSOEVER,
                      WHETHER DIRECT, INDIRECT, GENERAL, SPECIAL, COMPENSATORY,
                      CONSEQUENTIAL, AND/OR INCIDENTAL, LIQUIDATED, PUNITIVE
                      ARISING OUT OF OR RELATING TO RECOMMENDATION OF THE APP OR
                      SERVICES, THE CONDUCT OF USER OR ANYONE ELSE IN CONNECTION
                      WITH THE USE OF THE SERVICES, INCLUDING WITHOUT
                      LIMITATION, BODILY INJURY, EMOTIONAL DISTRESS, FINANCIAL
                      LOSS AND/OR ANY OTHER DAMAGES RESULTING FROM
                      COMMUNICATIONS OR MEETINGS WITH OTHER REGISTERED USERS OF
                      THE SERVICES OR AS A RESULT OF USING THE SERVICES. THIS
                      INCLUDES ANY CLAIMS, LOSSES OR DAMAGES ARISING FROM THE
                      CONDUCT OF USERS WHO HAVE REGISTERED UNDER FALSE PRETENSES
                      OR WHO ATTEMPT TO DEFRAUD OR HARM OTHER USERS.{" "}
                    </li>
                    <li className="py-1">
                      <u>Information Verification.</u> Emotionly and its
                      contractors may use various ways, including engaging third
                      party information verification service providers of
                      verifying information that users have provided. However,
                      none of those ways are perfect, and the User agrees that
                      Emotionly and its contractors will have no liability
                      towards the User arising from any incorrectly verified
                      information. At all times the User has the right to
                      undertake information verification of matched users with
                      whom the User is desirous of progressing and exploring.{" "}
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">8. Indemnification.</li>
                  <p>
                    The User agrees to indemnify, defend and hold harmless
                    Emotionly, its affiliates, subsidiary and parent companies,
                    and each of their officers, directors, employees, agents and
                    related third parties, for any losses, costs, liabilities
                    and expenses (including reasonable attorneys’ fees) relating
                    to or arising out of any third party claim that (a) the
                    User’s use of or inability to use the Site or Services, (b)
                    any user postings made by the User , (c) the User’s
                    violation of any terms of this Terms and Conditions or the
                    User’s violation of any rights of a third party, or (d) the
                    User’s violation of any applicable laws, rules or
                    regulations, or (e) the User’s providing any false
                    information to Emotionly or conspiring and abetting with any
                    third party for seemingly substantiating such false
                    information to appear as true. Emotionly reserves the right,
                    at its own cost, to assume the exclusive defence and control
                    of any matter otherwise subject to indemnification by the
                    User, the User will co-operate fully in asserting any
                    available defences in such case.
                  </p>

                  <li className=" font-semibold mt-3">
                    9. Communication & Privacy
                  </li>
                  <p>
                    Emotionly may use the User email address to send messages
                    notifying of important changes/ updates to the Services or
                    special offers. User can at any time opt out of this if User
                    does not want to receive such email messages. Users are
                    requested to review our Privacy Policy carefully to
                    understand the usage indicated here.
                  </p>

                  <li className=" font-semibold mt-3">10. Termination</li>
                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <p>
                        10.1 These Terms and Conditions become effective upon
                        the User logging / registering on the App and will
                        remain in effect in perpetuity unless terminated
                        hereunder. Either the User or Emotionly may terminate
                        the User account at any time, for any reason or no
                        reason, without explanation, effective upon sending
                        written notice to the other party. Emotionly reserves
                        the right to immediately suspend or terminate the User’s
                        access to any of the Services, without notice, for any
                        reason or no reason. Emotionly also reserve the right to
                        remove the User’s account information or data from
                        Services and any other records at any time at
                        Emotionly's sole discretion. Emotionly does not use the
                        User’s information once this Terms and Conditions are
                        terminated or the Services are not being used, however,
                        some information/ data about the User may remain
                        archived with Emotionly. In the event the account is
                        terminated or access denied or suspended due to the
                        breach of these Terms and Conditions or any other
                        reason, then the User agrees that fees paid to Emotionly
                        (if any) will be nonrefundable and all outstanding or
                        pending payments will immediately become due and
                        accelerated payment. The User may terminate the account
                        by accessing the Account Settings or the User can stop
                        accessing the Site and using and receiving the Services.
                        Non payment of renewal fees on time will also be an
                        indication of the User’s desire to terminate his/ her
                        account and discontinue receiving the Services.
                        Following any termination of any Registered User's use
                        of the Service, Emotionly reserves the right to send a
                        notice thereof to other Registered Users with whom the
                        User has corresponded. If the User wishes to continue
                        exchange with any of the other users after terminating
                        this Terms and Conditions, then that will be at the sole
                        discretion, responsibility and liability of such Users
                        and Emotionly will not be responsible for any outcome/
                        impact or result of such interactions.
                      </p>
                    </li>
                    <li className="py-1">
                      <p>
                        10.2 Termination shall not affect any liabilities
                        incurred by the User prior to the termination or for
                        acts performed while registered with the App which may
                        result in a dispute post termination nor any provision
                        expressed to survive or to be effective on termination
                        shall expire. The obligations set out in this Section
                        shall remain in full force and effect notwithstanding
                        termination.
                      </p>
                    </li>
                  </ul>

                  <li className=" font-semibold mt-3">11. Disclaimer</li>
                  <p>
                    YOUR USE OF THE APP IS AT YOUR RISK. THE INFORMATION,
                    MATERIALS AND SERVICES PROVIDED ON OR THROUGH THE APP ARE
                    PROVIDED "AS IS" WITHOUT ANY WARRANTIES OF ANY KIND
                    INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                    PARTICULAR PURPOSE, SECURITY OR NON-INFRINGEMENT OF
                    INTELLECTUAL PROPERTY. NEITHER ORGANIZATION, NOR ANY OF ITS
                    AFFILIATES WARRANT THE ACCURACY OR COMPLETENESS OF THE
                    INFORMATION, MATERIALS OR SERVICES PROVIDED ON OR THROUGH
                    THE APP. THE INFORMATION, MATERIALS AND SERVICES PROVIDED ON
                    OR THROUGH THE APP MAY BE OUT OF DATE, AND NEITHER
                    ORGANIZATION, NOR ANY OF ITS AFFILIATES MAKES ANY COMMITMENT
                    OR ASSUMES ANY DUTY TO UPDATE SUCH INFORMATION, MATERIALS OR
                    SERVICES. THE FOREGOING EXCLUSIONS OF IMPLIED WARRANTIES DO
                    NOT APPLY TO THE EXTENT PROHIBITED BY LAW. PLEASE REFER TO
                    YOUR LOCAL LAWS FOR ANY SUCH PROHIBITIONS. NO ADVICE OR
                    INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM
                    ORGANIZATION OR THROUGH THE APP WILL CREATE ANY WARRANTY NOT
                    EXPRESSLY MADE HEREIN.
                  </p>

                  <li className=" font-semibold mt-3">
                    12. LIMITATIONS OF LIABILITY
                  </li>
                  <p>
                    EMOTIONALY DOES NOT ASSUME ANY RESPONSIBILITY, OR WILL BE
                    LIABLE, FOR ANY DAMAGES TO, OR ANY VIRUSES THAT MAY INFECT
                    YOUR COMPUTER, TELECOMMUNICATION EQUIPMENT, OR OTHER
                    PROPERTY CAUSED BY OR ARISING FROM YOUR ACCESS TO, USE OF,
                    OR BROWSING THIS APP, OR YOUR DOWNLOADING OF ANY INFORMATION
                    OR MATERIALS FROM THIS APP. IN NO EVENT WILL ORGANIZATION,
                    OR ANY OF ITS OFFICERS, DIRECTORS, EMPLOYEES, SHAREHOLDERS,
                    AFFILIATES, AGENTS, SUCCESSORS OR ASSIGNS, NOR ANY PARTY
                    INVOLVED IN THE CREATION, PRODUCTION OR TRANSMISSION OF THE
                    APP, BE LIABLE TO YOU OR ANYONE ELSE FOR ANY INDIRECT,
                    SPECIAL, PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES
                    (INCLUDING, WITHOUT LIMITATION, THOSE RESULTING FROM LOST
                    PROFITS, LOST DATA OR BUSINESS INTERRUPTION) ARISING OUT OF
                    THE USE, INABILITY TO USE, OR THE RESULTS OF USE OF THE APP,
                    OR THE MATERIALS, INFORMATION OR SERVICES CONTAINED ON ANY
                    OR ALL OF THE APP, WHETHER BASED ON WARRANTY, CONTRACT, TORT
                    OR ANY OTHER LEGAL THEORY AND WHETHER OR NOT ADVISED OF THE
                    POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATIONS OF
                    LIABILITY DO NOT APPLY TO THE EXTENT PROHIBITED BY LAW.
                    PLEASE REFER TO YOUR LOCAL LAWS FOR ANY SUCH PROHIBITIONS.
                  </p>

                  <li className=" font-semibold mt-3">13. Force Majeure</li>
                  <p>
                    Neither Organization nor you shall be responsible for
                    damages or for delays or failures in performance resulting
                    from acts or occurrences beyond their reasonable control,
                    including, without limitation: fire, lightning, explosion,
                    power surge or failure, water, acts of God, war, revolution,
                    civil commotion or acts of civil or military authorities or
                    public enemies: any law, order, regulation, ordinance, or
                    requirement of any government or legal body or any
                    representative of any such government or legal body; or
                    labor unrest, including without limitation, strikes,
                    slowdowns, picketing, or boycotts; inability to secure raw
                    materials, transportation facilities, fuel or energy
                    shortages, or acts or omissions of other common carriers.
                  </p>

                  <li className=" font-semibold mt-3">
                    14. Dispute Resolution
                  </li>
                  <p>
                    In case of any dispute arising out of or in connection with
                    this Terms and Conditions, the User agrees to first try to
                    resolve the dispute informally by contacting the Customer
                    Support Team at contact@emotionly.app but if that doesn't
                    resolve that then it shall be through arbitration in
                    accordance with the Arbitration and Conciliation Act, 1996.
                    The arbitration shall be held in the city of Delhi, India.
                    The language of the arbitration shall be English. The
                    arbitration award shall be final and binding on the parties.
                    The User agrees that the arbitration award may be enforced
                    in any court of competent jurisdiction.
                  </p>

                  <li className=" font-semibold mt-3">15. Other Provisions</li>

                  <p>
                    Any claim relating to, and the use of, this App and the
                    materials contained herein is governed by the laws of India.
                    You consent to the exclusive jurisdiction of the state and
                    supreme courts located in Delhi, India. A printed version of
                    these Terms of Service will be admissible in judicial and
                    administrative proceedings based upon or relating to these
                    Terms of Service to the same extent and subject to the same
                    conditions as other business documents and records
                    originally generated and maintained in printed form.
                  </p>
                  <br />
                  <p>
                    These Terms of Service set forth the entire understanding
                    and agreement between us with respect to the subject matter
                    hereof. We do not guarantee continuous, uninterrupted or
                    secure access to our App, and operation of the App may be
                    interfered with by numerous factors outside of our control.
                    If any provision of these Terms of Service is held to be
                    invalid or unenforceable, such provision shall be struck and
                    the remaining provisions shall be enforced. You agree that
                    these Terms of Service and all incorporated agreements may
                    be automatically assigned by Organization in our sole
                    discretion. Headings are for reference purposes only and in
                    no way define, limit, construe or describe the scope or
                    extent of such section. Our failure to act with respect to a
                    breach by you or others does not waive our right to act with
                    respect to subsequent or similar breaches. All sections
                    which by their context ought to survive this agreement shall
                    survive any termination or expiration of this Agreement.
                  </p>

                  <br />

                  <ul className="gap-2 py-1 ">
                    <li className="py-1">
                      <p>
                        15.1 <b>Agency:</b> This is a principal-to-principal
                        relationship and does not attempt to create any
                        employee-employer or agency relationship. Services are
                        being provided by Us as an independent entity and
                        nothing contained herein shall be deemed to create any
                        association, partnership, joint venture or relationship
                        of principal and agent or master and servant, or
                        employer and employee between the Parties hereto or any
                        affiliates or subsidiaries thereof or to provide the
                        User with the right, power or authority, whether express
                        or implied to create any such duty or obligation on
                        behalf of Emotionly.
                      </p>{" "}
                    </li>
                    <li className="py-1">
                      15.2 <b>Assignments:</b> Emotionly may assign, in whole or
                      in part, the benefits or obligations of this Agreement to
                      its associate’s of affiliates of other group company, or
                      any other company, pursuant to a restructuring or
                      re-organization or demerger of its organization or
                      operations causing a change in management or something of
                      the nature. Emotionly shall not require approval or
                      consent of the User, it can at its discretion provide an
                      intimation of such assignment to the User.
                    </li>
                    <li className="py-1">
                      15.3 <b>Waiver:</b> Unless otherwise expressly stated,
                      failure to exercise or delay in exercising a right or
                      remedy, hereunder shall not constitute a waiver of the
                      right or remedy or a waiver of any other rights or
                      remedies, and no single or partial exercise of any right
                      or remedy, hereunder shall prevent any further exercise of
                      the right or remedy or the exercise of any other right or
                      remedy.
                    </li>
                    <li className="py-1">
                      15.4 <b>Survival of Provisions:</b> Terms and Conditions
                      will survive termination of the same by the User or by
                      Emotionly.
                    </li>
                    <li className="py-1">
                      15.5 <b>Severability:</b> If any provision, hereunder
                      becomes, in whole or in part, invalid or unenforceable but
                      would be valid or enforceable if some part of that
                      provision was deleted, that provision shall apply with
                      such deletions as may be necessary to make it valid. If
                      any Court/Tribunal of competent jurisdiction holds any of
                      the provisions, hereunder unlawful or otherwise
                      ineffective, the remainder shall remain in full force and
                      the unlawful or otherwise ineffective provision shall be
                      substituted by a new provision reflecting the intent of
                      the provision so substituted.
                    </li>
                    <li className="py-1">
                      15.6 <b>Notices:</b> All notices, requests, demands,
                      waivers and other communications required or permitted to
                      be given hereunder shall be contact@emotionly.app
                    </li>
                    <li className="py-1">
                      15.7 <b>Right to Seek Injunction:</b> The User accepts and
                      acknowledges that the breach of the Terms and Conditions
                      may cause Emotionly irreparable harm, and thus confirms
                      and accepts that Emotionly will be entitled to seek
                      extraordinary relief in court, including but not limited
                      to temporary restraining orders, preliminary injunctions
                      and permanent injunctions without any preconditions, in
                      addition to and without prejudice to any other rights or
                      remedies that Emotionly may have under law and tort.
                    </li>
                    <li className="py-1">
                      15.8 <b>Miscellaneous:</b> Terms and Conditions, Privacy
                      Policy and other policies on the App or made known by us
                      from time to time, comprise the entire agreement between
                      the User and us regarding the use of this Service,
                      superseding any prior agreements/ correspondences between
                      the User and us related to the User’s use of this App or
                      Services (including, but not limited to, any prior
                      versions of Terms and Conditions). If any provision of the
                      Terms and Conditions are held invalid, the remainder will
                      continue in full force and effect. The titles are for
                      convenience only and have no legal or contractual effect.
                    </li>
                  </ul>
                </ol>
              </div>

              {/* Footer Section */}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Terms;
